import React from 'react';
import './Banner.css';
import Typical from 'react-typical'

const Banner = () => {
    return (
      
        <div className='hero'>
          <div className=" container">

          
          <div className="" >
            <div className="d-flex  align-items-center justify-content-center hero-div" >
            <div>
            <Typical steps={["I am Sahara Banu", 2000]} loop={Infinity} wrapper="h2" />
        <Typical className="typical"
          steps={["FRONT-END DEVELOPER", 500, "WEB DEVELOPER", 500]}
          loop={Infinity}
          wrapper="h3"
        />
           
            <br />
            <a href="https://drive.google.com/file/d/1PCWbhKm2n6FCSSPhvHt3eqE7MSiyAm39/view?usp=sharing" target="_blank" rel="noreferrer"style={{textDecoration:'none'}} className="resume rounded-pill mb-5"> My Resume</a>
            <br /> <br />

            <div className="banner-a">
            <a className=""href="https://www.facebook.com/sahara.banu.796/" target="_blank" rel="noreferrer"><i className="fab fa-facebook"></i></a>
            <a className="px-3" href="https://github.com/saharabanu" target="_blank" rel="noreferrer"><i className="fab fa-github"></i></a>
            <a className="" href="https://www.linkedin.com/in/saharabanu/" target="_blank" rel="noreferrer"><i className="fab fa-linkedin"></i></a>
            </div>
            </div>
            

            </div>
            
          </div>
          
        
         
          
          
          </div>
        </div>
      
    

        
    )
};

export default Banner;